import React from "react";

interface Props {
  total: number;
  threshold?: number; // free shipping amount
}

const FreeShippingBar: React.FC<Props> = ({
  total,
  threshold = 100, // change as needed
}) => {
  const remaining = Math.max(threshold - total, 0);
  const progress = Math.min((total / threshold) * 100, 100);

  return (
    <div className="px-4 py-3 bg-gray-100 border-b">
      {/* Text */}
      <p className="text-sm text-green-600 font-medium">
        {remaining > 0
          ? `Spend ${remaining.toFixed(2)} AED more to reach free shipping!`
          : "🎉 You’ve unlocked free shipping!"}
      </p>

      {/* Progress Bar */}
      <div className="mt-2 h-2 w-full bg-gray-300 rounded-full overflow-hidden">
        <div
          className="h-full bg-green-600 transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default FreeShippingBar;